import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IItinerariesSort } from 'src/app/models';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';
import { ItinerariesApiRoutes } from './itineraries-api.routes';

@Injectable({
  providedIn: 'root',
})
export class ItinerariesHttpService extends BaseHttpService {
  private baseURL = `itineraries`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getRouteItineraries(routeId: number, page: number, size: number, sort: IItinerariesSort) {
    const query = `page=${page}&size=${size}&sort=${sort.type}&direction=${sort.direction}`;
    const url = this.routerService.mount(`${this.baseURL}/${ItinerariesApiRoutes.ROUTE}/${routeId}?${query}`);
    return this.read(url);
  }

  public getItinerary(itineraryId: number) {
    const url = this.routerService.mount(`${this.baseURL}/${itineraryId}`);
    return this.read(url);
  }

  public updateItineraryCode(itineraryId: number, code: string) {
    const url = this.routerService.mount(
      `${this.baseURL}/${itineraryId}/${ItinerariesApiRoutes.CODE}/${encodeURIComponent(code)}`,
    );
    return this.update({}, url);
  }
}
